import React from "react";
import { useLang, pick } from "../i18n/LanguageContext";
import { t } from "../i18n/translations";
import ViewportVideo from "./ViewportVideo";

// Hero-showreel: pätkiä sivun kaikista casevideoista peräkkäin. Tiedosto
// renderöidään scripts/build-showreel.swift-skriptillä public/videos-kansioon
// (ei bundleen), ja se looppaa natiivisti. Hero on aina mykkä. Poster
// (showreelin ensimmäinen kuva) täyttää H-maskin ennen kuin video latautuu,
// ja toisto pysähtyy kun hero vieritetään pois näkymästä.
const SHOWREEL_SRC = "/videos/hetki-showreel.mp4";

const Hero = ({ children }) => {
  const { lang } = useLang();
  const tr = pick(lang);

  return (
    <section className="hero" aria-label={tr(t.home.heroLabel)}>
      <div className="hero__video-mask">
        <ViewportVideo className="hero__video" src={SHOWREEL_SRC} />
      </div>
      {children && <div className="hero__scrim" aria-hidden="true" />}
      {children && <div className="hero__overlay">{children}</div>}
    </section>
  );
};

export default Hero;
